import { format, formatDistanceToNow } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz'
// ----------------------------------------------------------------------

export function fDisplayDate(date, type = "dd/MM/yyyy") {
  if (date && !isNaN(new Date(date).getTime())) {
    return format(new Date(date), type);
  }
  return 'Invalid Date'
}


export function fDate(date, type = "yyyy-MM-dd") {
  if (date && !isNaN(new Date(date).getTime())) {
    // console.log(date, typeof date)
    let dd, MM, YYYY;
    if (typeof date === "string") {
      const dateArray = date.split('-');
      dd = dateArray[2];
      MM = dateArray[1];
      YYYY = dateArray[0];
    }
    else {
      // console.log(date?.$D)
      if (date?.$D) {
        dd = String(date?.$D).padStart(2, '0');
        MM = String(date?.$M + 1).padStart(2, '0');
        YYYY = date?.$y;
      }
      else {
        dd = String(date.getDate()).padStart(2, '0');
        MM = String(date.getMonth() + 1).padStart(2, '0');
        YYYY = date.getFullYear();
      }
    }
    // console.log(type)
    if (type === "yyyy-MM-dd") {
      return `${YYYY}-${MM}-${dd}`
    }
    else if (type === "yyyy") {
      return `${YYYY}`;
    }
    else if (type === "MM") {
      return `${MM}`;
    }
    else if (type === "dd") {
      return `${dd}`;
    }
    else {
      return `${dd}/${MM}/${YYYY}`;
    }
  }
  return 'Invalid Date'
}

export function fMonth(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'MMM');
  }
  return 'Invalid Month'
}

export function fDay(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd');
  }
  return 'Invalid Day'
}

export function fYear(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'yyyy');
  }
  return 'Invalid Year'
}

export function fDateTime(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd MMM yyyy HH:mm');
  }
  return 'Invalid Date'
}

export function fDateTimeSuffix(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd/MM/yyyy hh:mm p');
  }
  return 'Invalid Date'
}

export function fToNow(date) {
  if (date && !isNaN(new Date(date).getTime())) {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
    });
  }
  return 'Invalid Date'
}
